import { createApp } from 'vue'
import { START_LOCATION } from 'vue-router'
import { language, tr } from '@/i18n'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { setApiHandlers } from './api/client'
import { useAuthStore } from './stores/auth'
import { useReauth } from './composables/useReauth'
import './style.css'

const app = createApp(App)
// English or Marathi everywhere (src/i18n): templates call tr('English text').
app.config.globalProperties.tr = tr
document.documentElement.lang = language.value === 'mr' ? 'mr-IN' : 'en-IN'
app.use(createPinia())
app.use(router)

const auth = useAuthStore()
const reauth = useReauth()

setApiHandlers({
  onUnauthenticated: () => {
    auth.reset()
    // During the first navigation (a link opened in a new tab: an invite, a
    // password reset) the route guard decides; redirecting here would cancel it.
    const current = router.currentRoute.value
    if (current !== START_LOCATION && !current.meta.public) {
      void router.push({ name: 'login', query: { reason: 'signed-out' } })
    }
  },
  onMfaRequired: (state) => {
    auth.user = null
    auth.pendingMfa = state
    const target = state === 'enrollment_required' ? 'mfa-setup' : 'mfa'
    if (router.currentRoute.value.name !== target) void router.push({ name: target })
  },
  onReauthenticationRequired: () => reauth.request(),
})

app.mount('#app')
